import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import Herbotai from './Herbotai';
import { OAuthCallback } from './components/OAuthCallback';
import { CallbackPage } from './pages/CallbackPage';
import { OAuthProvider } from './services/oauthService';
import './App.css';

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/" element={<Herbotai />} />
          <Route path="/oauth/callback" element={<CallbackPage />} />
          <Route path="/oauth/google/callback" element={<OAuthCallback provider={OAuthProvider.GOOGLE} />} />
          <Route path="/oauth/kakao/callback" element={<OAuthCallback provider={OAuthProvider.KAKAO} />} />
          <Route path="/oauth/naver/callback" element={<OAuthCallback provider={OAuthProvider.NAVER} />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
